import React from "react";
import styled from "styled-components";
import { useLocation } from "react-router";
import { motion } from "framer-motion";
import iconWhatsApp from '../assets/whatsapp.svg'


const WhatsAppIcon = () => <img src={iconWhatsApp} alt="iconW" />;

const WhatsAppShareButton = ({ message }) => {
  const location = useLocation();
  const currentUrl = window.location.origin + location.pathname;

  const encodedMessage = encodeURIComponent(`${message} ${currentUrl}`);

  const handleShare = () => {
    const whatsappUrl = `https://wa.me/?text=${encodedMessage}`;
    window.open(whatsappUrl, "_blank");
  };

  return (
    <BtnWhatsAppContainer
    whileHover={{ scale: 1.1 }}
    whileTap={{ scale: 0.95 }}
    >
      <Button onClick={handleShare}>
      <WhatsAppIcon />
      Compartir este producto por WhatsApp
      </Button>
    </BtnWhatsAppContainer>
    
  );
};
const BtnWhatsAppContainer = styled(motion.div) `
  min-width: 90%;
  max-width: 90%;
  margin: 5px auto;
`
const Button = styled.button`
  background-color: #25d366;
  color: white;
  padding: 10px 20px;
  border: none;
  font-weight: bold;
  cursor: pointer;
  gap: 8px;
  transition: background 0.3s;
  width: 100%;
  text-align: center;
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    height: 40px;
    filter: invert(100%);
  }

  &:hover {
    background-color: #1ebe5b;
  }
`;
export default WhatsAppShareButton;